import { AlertFooterBar } from '../../elements/FooterAlert';

type WaveDetailAllocationSelectionFooterProps = {
  selectedCount: number;
  onClear: () => void;
  onCancelAllocations: () => void;
};

export function WaveDetailAllocationSelectionFooter({
  selectedCount,
  onClear,
  onCancelAllocations,
}: WaveDetailAllocationSelectionFooterProps) {
  if (selectedCount < 1) {
    return null;
  }

  return (
    <AlertFooterBar
      message={
        selectedCount === 1
          ? '1 allocation selected'
          : `${selectedCount} allocations selected`
      }
      cancel={onClear}
      cancelButtonText="Clear"
      save={onCancelAllocations}
      saveButtonText="Cancel Allocations"
    />
  );
}
